export const WINDOW_FORMATION_SUMMARY_ITEM = {
  label: 'Window',
  accessor: 'name',
};
